var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useMemo } from "react";
import { DatagridConfigurable, FunctionField, List, TextField, TextInput, WrapperField, useGetMany, useListContext, useNotify, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { IconButton, Stack, Box, Chip, Tooltip, Typography } from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ActionsColumn } from "../../components/ActionButons";
import { useTranslation } from "react-i18next";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { WizardSteps } from "./TallySheetWizard";
import { ContestItem } from "@/components/ContestItem";
import { AreaItem } from "@/components/AreaItem";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
import { AuthContext } from "@/providers/AuthContextProvider";
import { EStatus } from "@/types/TallySheets";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { FETCH_DOCUMENT } from "@/queries/FetchDocument";
import { downloadUrl } from "@sequentech/ui-core";
import { useLocation, useNavigate } from "react-router-dom";
var OMIT_FIELDS = ["id", "channel", "area_id", "contest_id"];
var Filters = [
    _jsx(TextInput, { label: "Area", source: "area_id" }, 0),
    _jsx(TextInput, { label: "Contest", source: "contest_id" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Channel", source: "channel" }, 3),
    _jsx(TextInput, { label: "Version", source: "version" }, 4),
    _jsx(TextInput, { label: "Created by", source: "created_by_user_id" }, 5),
    _jsx(TextInput, { label: "Reviewed by", source: "reviewed_by_user_id" }, 6),
    _jsx(TextInput, { label: "Status", source: "status" }, 7),
    _jsx(TextInput, { label: "Import", source: "import_id" }, 8),
    _jsx(TextInput, { label: "Labels", source: "labels" }, 9),
    _jsx(TextInput, { label: "Annotations", source: "annotations" }, 10),
];
var ImportedVersionSourceContext = React.createContext(new Map());
export var ListTallySheetVersions = function (props) {
    var tallySheet = props.tallySheet, doAction = props.doAction, approveAction = props.approveAction, disapproveAction = props.disapproveAction, setShowVersionsTable = props.setShowVersionsTable;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var authContext = useContext(AuthContext);
    var canView = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_VIEW);
    var canReview = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_REVIEW);
    var canViewImport = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_IMPORT_VIEW);
    var viewAction = function (id) {
        doAction(WizardSteps.View, id);
    };
    var actions = function (record) { return [
        {
            icon: (_jsx(Tooltip, { title: t("tallysheet.common.show"), children: _jsx(VisibilityIcon, {}) })),
            action: viewAction,
            showAction: function () { return canView; },
            label: t("tallysheet.common.show"),
        },
        {
            icon: (_jsx(Tooltip, { title: t("tallysheet.common.approve"), children: _jsx(PublishedWithChangesIcon, {}) })),
            action: approveAction,
            showAction: function () { return canReview && record.status === EStatus.PENDING; },
            label: t("tallysheet.common.approve"),
        },
        {
            icon: (_jsx(Tooltip, { title: t("tallysheet.common.disapprove"), children: _jsx(UnpublishedIcon, {}) })),
            action: disapproveAction,
            showAction: function () { return canReview && record.status === EStatus.PENDING; },
            label: t("tallysheet.common.disapprove"),
        },
    ]; };
    var Empty = function () { return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("tallysheet.empty.header") }) })); };
    function goBack() {
        setShowVersionsTable(false);
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeaderStyles.Wrapper, { children: _jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(ElectionHeaderStyles.SubTitle, { children: t("tallysheet.versionsTable.title") }), _jsx(Chip, { label: tallySheet.channel }), _jsx(AreaItem, { record: tallySheet.area_id }), _jsx(ContestItem, { record: tallySheet.contest_id })] }) }), _jsx(List, { disableSyncWithLocation: true, sort: { field: "version", order: "DESC" }, queryOptions: {
                    refetchInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
                }, resource: "sequent_backend_tally_sheet", actions: _jsx(ListActions, { withImport: false, withExport: false }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: tallySheet.tenant_id || undefined,
                    election_event_id: tallySheet.election_event_id || undefined,
                    election_id: tallySheet.election_id || undefined,
                    area_id: tallySheet.area_id || undefined,
                    contest_id: tallySheet.contest_id || undefined,
                    channel: tallySheet.channel || undefined,
                }, filters: Filters, empty: _jsx(Empty, {}), children: _jsx(ImportedVersionSourceContextProvider, { canViewImport: canViewImport, children: _jsxs(DatagridConfigurable, { bulkActionButtons: false, omit: OMIT_FIELDS, sx: {
                            flexGrow: 1,
                            overflowX: "auto",
                            width: "100%",
                            maxWidth: "100%",
                        }, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "channel" }), _jsx(FunctionField, { source: "contest_id", label: t("tallysheet.table.contest"), render: function (record) { return (_jsx(ContestItem, { record: record.contest_id })); } }), _jsx(FunctionField, { source: "area_id", label: t("tallysheet.table.area"), render: function (record) { return (_jsx(AreaItem, { record: record.area_id })); } }), _jsx(FunctionField, { label: t("tallysheet.versionsTable.version"), render: function (record) { return _jsx(TextField, { source: "version" }); } }, "Version"), _jsx(FunctionField, { label: t("tallysheet.versionsTable.createdBy"), render: function (record) { return _jsx(TextField, { source: "created_by_user_id" }); } }, "Created by"), _jsx(TextField, { source: "created_at" }), _jsx(FunctionField, { label: t("tallysheet.versionsTable.reviewedBy"), render: function (record) {
                                    return record.reviewed_at ? (_jsx(TextField, { source: "reviewed_by_user_id" })) : ("-");
                                } }, "Reviewed by"), _jsx(FunctionField, { label: t("tallysheet.versionsTable.reviewedAt"), render: function (record) {
                                    return record.reviewed_at ? _jsx(TextField, { source: "reviewed_at" }) : "-";
                                } }, "reviewed_at"), _jsx(TextField, { source: "status" }), _jsx(FunctionField, { source: "labels", label: t("tallysheet.table.labels"), render: function (record) {
                                    return formatJsonValue(record.labels);
                                } }), _jsx(FunctionField, { source: "annotations", label: t("tallysheet.table.annotations"), render: function (record) {
                                    return formatJsonValue(record.annotations);
                                } }), _jsx(FunctionField, { label: t("tallysheet.versionsTable.sourceImport"), render: function (record) { return (_jsx(ImportedVersionSource, { record: record, electionEventId: String(tallySheet.election_event_id), canViewImport: canViewImport })); } }, "source-import"), _jsx(WrapperField, { source: "actions", label: "Actions", children: _jsx(FunctionField, { label: t("tallysheet.table.area"), render: function (record) { return (_jsx(ActionsColumn, { actions: actions(record) })); } }) })] }) }) }), _jsx(WizardStyles.Toolbar, { children: _jsxs(WizardStyles.BackButton, { color: "info", onClick: goBack, className: "ts-versions-back-button", children: [_jsx(ArrowBackIosIcon, {}), t("common.label.back")] }) })] }));
};
var ImportedVersionSourceContextProvider = function (_a) {
    var children = _a.children, canViewImport = _a.canViewImport;
    var _b = useListContext().data, versions = _b === void 0 ? [] : _b;
    var importIds = useMemo(function () {
        return Array.from(new Set(versions
            .map(function (version) { return version.import_id; })
            .filter(function (importId) { return !!importId; })));
    }, [versions]);
    var _c = useGetMany("sequent_backend_tally_sheet_import", { ids: importIds }, { enabled: canViewImport && importIds.length > 0 }).data, imports = _c === void 0 ? [] : _c;
    var importsById = useMemo(function () {
        var importMap = new Map();
        imports.forEach(function (item) {
            importMap.set(item.id, item);
        });
        return importMap;
    }, [imports]);
    return (_jsx(ImportedVersionSourceContext.Provider, { value: importsById, children: children }));
};
var ImportedVersionSource = function (_a) {
    var record = _a.record, electionEventId = _a.electionEventId, canViewImport = _a.canViewImport;
    var t = useTranslation().t;
    var notify = useNotify();
    var location = useLocation();
    var navigate = useNavigate();
    var importId = record.import_id;
    var importReferencesById = useContext(ImportedVersionSourceContext);
    var sourceImport = importId ? importReferencesById.get(importId) : undefined;
    var fetchDocument = useLazyQuery(FETCH_DOCUMENT, {
        fetchPolicy: "no-cache",
    })[0];
    if (!importId || !canViewImport) {
        return _jsx(Typography, { variant: "body2", children: "-" });
    }
    var openImport = function (event) {
        event.stopPropagation();
        var nextSearch = new URLSearchParams(location.search);
        nextSearch.set("tabId", "tally-sheet-imports");
        nextSearch.set("tallySheetImportId", importId);
        navigate({ pathname: location.pathname, search: "?".concat(nextSearch.toString()) });
    };
    var downloadSource = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, url, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(sourceImport === null || sourceImport === void 0 ? void 0 : sourceImport.source_document_id)) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchDocument({
                            variables: {
                                electionEventId: electionEventId,
                                documentId: sourceImport.source_document_id,
                            },
                        })];
                case 2:
                    data = (_b.sent()).data;
                    url = (_a = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _a === void 0 ? void 0 : _a.url;
                    if (!url) {
                        throw new Error(String(t("tallySheetImport.notifications.sourceUrlError")));
                    }
                    return [4 /*yield*/, downloadUrl(url, sourceImport.source_file_name || "tally-sheet-import-".concat(importId))];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    notify(error_1 instanceof Error
                        ? error_1.message
                        : t("tallySheetImport.notifications.sourceDownloadError"), { type: "error" });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, { gap: 0.5, children: [_jsxs(Typography, { variant: "caption", color: "text.secondary", children: [t("tallysheet.versionsTable.importStatus"), ": ", (sourceImport === null || sourceImport === void 0 ? void 0 : sourceImport.status) || "-"] }), _jsxs(Stack, { direction: "row", gap: 1, flexWrap: "wrap", children: [_jsx(Tooltip, { title: String(t("tallysheet.versionsTable.openImport")), children: _jsx(IconButton, { size: "small", onClick: openImport, children: _jsx(OpenInNewIcon, { fontSize: "small" }) }) }), _jsx(Tooltip, { title: String(t("tallysheet.versionsTable.sourceFile")), children: _jsx("span", { children: _jsx(IconButton, { size: "small", onClick: downloadSource, disabled: !(sourceImport === null || sourceImport === void 0 ? void 0 : sourceImport.source_document_id), children: _jsx(DownloadIcon, { fontSize: "small" }) }) }) })] })] }));
};
var formatJsonValue = function (value) {
    if (value === null || value === undefined || value === "") {
        return "-";
    }
    if (typeof value === "string") {
        return value;
    }
    try {
        return JSON.stringify(value);
    }
    catch (_error) {
        return String(value);
    }
};
